import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initGA4 } from "@/lib/analytics";
import { initWebVitals } from "@/lib/webVitals";

// Initialize Google Analytics 4 (only in browser)
if (typeof window !== 'undefined') {
  initGA4();
  initWebVitals();
}

const rootElement = document.getElementById("root")!;

// Standard React rendering
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
